import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-participant-submission-view',
  templateUrl: './participant-submission-view.component.html',
  styleUrls: ['./participant-submission-view.component.scss']
})
export class ParticipantSubmissionViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
